import { Plugin } from 'vue'

import { Locales, useLocalization } from '@/shared/composables/localization'

export const localizationPlugin: Plugin = {
  install: () => {
    const { fetchLanguages, languagesMap } = useLocalization()
    fetchLanguages()
      .then((locales) => {
        if (!Array.isArray(locales)) {
          return
        }
        locales.forEach((locale) => {
          switch (locale) {
          case Locales.EN_GB:
            languagesMap.set(Locales.EN_GB, ['English', 'English'])
            break
          case Locales.RU_RU:
            languagesMap.set(Locales.RU_RU, ['Русский', 'Русский - Russian'])
            break
          }
        })
      }).catch((e: Error) => {
        console.error(e.message)
      })
  },
}
